import React, {Component} from 'react';
import '../css/TextInput.css';
import {COLORS} from '../constants';


class TextInput extends Component {

  static defaultProps = {
    type: 'text',
    autoFocus: false,
    isTextArea: false,
    disabled: false,
    textAreaRows: 2,
    onChange: () => undefined,
  }

  state = {
    isFocused: false,
  }

  handleFocus = (event) => {
    console.log('focus')
    this.setState({isFocused: true});
  }

  handleBlur = (event) => {
    console.log('blur')
    this.setState({isFocused: false});
  }

  render() {
    const {
      label,
      type,
      placeholder,
      isTextArea,
      inputStyle,
      disabled,
      textAreaRows,
      onChange,
      error,
    } = this.props;

    const s = {
      container: {
        fontFamily: 'verdana',
        textAlign: 'left',
      },
      labelContainer: {
        padding: '5px 0px',
      },
      label: {
        color: COLORS.gray500,
        fontSize: '80%',
      },
      inputContainer: {

      },
      input: {
        border: 'solid 1px ' + COLORS.lightGray,
        borderRadius: '2px',
        fontSize: '100%',
        color: COLORS.fadedBlack,
        padding: '15px 10px',
        width: '100%',
        resize: 'vertical',
        backgroundColor: COLORS.fadedWhite,
      },
      errorContainer: {
        padding: '5px 0px',
      },
      error: {
        color: COLORS.softRed,
        fontSize: '80%',
      },
    }

    if (inputStyle) {
      s.input = {...s.input, ...inputStyle};
    }

    if (disabled) {
      s.input = {...s.input, color: COLORS.gray500};
    }

    if (error) {
      s.input = {...s.input, border: 'solid 1px ' + COLORS.softRed}
    }

    if (this.state.isFocused) {
      s.input = {...s.input, border: 'solid 1px ' + COLORS.tealNew}
    }

    const inputProps = {
      ref: (el) => this.input = el,
      style: s.input,
      className: "TextInput-input",
      type,
      placeholder,
      disabled,
      onChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
    }

    const inputClass = disabled
      ? 'hover-disabled'
      : '';

    return(
      <div style={s.container}>
        {label &&
          <div style={s.labelContainer}>
            <div style={s.label}>
              {label}
            </div>
          </div>
        }

        <div style={s.inputContainer}>
        {isTextArea
          ?
          <textarea 
            {...inputProps} 
            rows={textAreaRows} 
            className={inputClass}
          />
          :
          <input 
            {...inputProps} 
            className={inputClass}
          />
        }
        </div>

        {error &&
          <div style={s.errorContainer}>
            <div style={s.error}>
              {error}
            </div>
          </div>
        }
      </div>
    )
  }
}


export default TextInput;



// WEBPACK FOOTER //
// ./src/main/TextInput.js